/**
 *
 * SubscriptionDetailsCard
 *
 */

import React from 'react'
import { Row, Typography } from 'antd'

const { Text } = Typography

function SubscriptionDetailsCard() {
  return (
    <div className="subscriptions-details-card">
      <Row>
        <Text className="subscriptions-details-info">
          Usage and bandwidth for live encoding of input stream ($0.04/min),
          video stream delivery ($0.0012/min), live simulcasting ($0.02/min per
          simulcast target) and video storage ($0.003/min) apply. Billed at the
          end of each payment cycle.
        </Text>
      </Row>
    </div>
  )
}

export default SubscriptionDetailsCard
